<template>
    <Transition name="fade">
        <div
            v-if="isShow && isWidgetsReady && widgets.length > 0"
            class="widgetSwitch"
            v-bind:style="{
                zIndex: zIndexMapping[ZIndex.Widget],
                bottom: `${widgetSwitchBottom}px`,
            }"
        >
            <Transition name="slide">
                <div v-if="isExpanded" class="widgetSwitch-item-container">
                    <template
                        v-for="(widget, index) in widgets"
                        v-bind:key="widget.positionId"
                    >
                        <div
                            class="item"
                            v-bind:data-position-id="widget.positionId"
                            v-bind:data-order="index + 1"
                            v-on:click="openWidget(widget.positionId)"
                        >
                            <img v-bind:src="widget.icon" alt="">
                        </div>
                        <div v-if="index < widgets.length - 1" class="divider" />
                    </template>
                </div>
            </Transition>

            <div
                class="widgetSwitch-button"
                v-bind:class="{ expanded: isExpanded }"
                v-bind:data-position-id="defaultWidget.positionId"
                v-on:click="isExpanded = !isExpanded"
            >
                <LazyIcon v-if="isExpanded" name="system:cross" />
                <img
                    v-else
                    v-bind:src="defaultWidget.icon"
                    alt=""
                >
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
    import { LazyIcon } from '@sbo/icons-vue';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import { ZIndex } from '@/interface/enum';
    import { zIndexMapping } from '@/libraries/helpers/zIndexHelper';
    import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
    import { useWidgetStore } from '@/stores/widgetStore';

    const WIDGET_SWITCH_BOTTOM_GAP = 12;

    const { widgets, activeWidget, defaultWidget, isWidgetsReady, isExpanded } = storeToRefs(useWidgetStore());
    const { openWidget } = useWidgetStore();
    const { isShowWidgetSwitch, sportsFooterHeight } = storeToRefs(useHeaderDisplayStore());
    const isShow = computed(() => isShowWidgetSwitch.value && !activeWidget.value);
    const widgetSwitchBottom = computed(() => sportsFooterHeight.value + WIDGET_SWITCH_BOTTOM_GAP);
</script>

<style lang="scss" scoped>
    @import "@/scss/components/widgetSwitch2";
</style>
